/**
 * IndexedDB wrapper minimale per salvare/leggere/cancellare clip audio
 * (Blob) sul dispositivo. Le clip NON vengono mai caricate sui server.
 *
 * Schema: db="smartdream_audio_clips", store="clips" (keyPath: id)
 * Record: { id, type, at, duration_sec, blob, createdAt }
 */

const DB_NAME = "smartdream_audio_clips";
const STORE = "clips";
const VERSION = 1;

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const s = db.createObjectStore(STORE, { keyPath: "id" });
        s.createIndex("createdAt", "createdAt");
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function saveClip({ id, type, at, duration_sec, blob }) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put({
      id,
      type,
      at,
      duration_sec,
      blob,
      createdAt: Date.now(),
    });
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function getClip(id) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).get(id);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function listClips() {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });
}

export async function deleteClip(id) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function deleteAllClips() {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).clear();
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

/** Elimina le clip più vecchie di `maxDays` giorni (default 30). */
export async function purgeExpiredClips(maxDays = 30) {
  const cutoff = Date.now() - maxDays * 24 * 60 * 60 * 1000;
  const clips = await listClips();
  const expired = clips.filter((c) => (c.createdAt || 0) < cutoff);
  for (const c of expired) {
    await deleteClip(c.id);
  }
  return expired.length;
}
